import { UnitSystem } from '@ravago/shared/page-data/models/config';
import { BasicFacetTermV2, ViewType } from '@ravago/shared/page-data/models/elastic';

interface Props {
   facets: Array<{ facetName: string; terms: BasicFacetTermV2[] }>;
   search: string;
   page: number;
   tab: 'product' | 'brand' | 'caseStudy';
   view: ViewType;
   unit: UnitSystem;
}

export const buildQueryKey = (props: Props) => ['product-portfolio', props];
